export const inputs = {
  selectedTime: {
    name: 'selectedTime',
    placeholder: '',
    rules: []
  },
  customerName: {
    name: 'customerName',
    placeholder: 'Nome',
    rules: []
  },
  customerPhone: {
    name: 'customerPhone',
    placeholder: 'Telefone',
    rules: [],
  },
  customerAddress: {
    name: 'customerAddress',
    placeholder: 'Endereço',
    rules: []
  },
  customerFiscalNoteDocument: {
    name: 'customerFiscalNoteDocument',
    placeholder: 'Doc. Nota Fiscal (CPF/CNPJ)',
    rules: []
  },
  brand: {
    name: 'brand',
    placeholder: 'Marca',
    rules: [],
  },
  quantity: {
    name: 'quantity',
    placeholder: 'Quantidade',
    rules: []
  },
  address: {
    name: 'address',
    placeholder: 'Endereço',
    rules: [{ required: true, message: 'Endereço é obrigatório!' }]
  },
  complement: {
    name: 'complement',
    placeholder: 'Complemento',
    rules: []
  },
  price: {
    name: 'price',
    placeholder: 'Valor',
    rules: []
  },
  priceWithDiscount: {
    name: 'priceWithDiscount',
    placeholder: 'Valor com desconto',
    rules: []
  },
  discount: {
    name: 'discount',
    placeholder: 'Desconto',
    rules: []
  },
  change: {
    name: 'change',
    placeholder: 'Troco',
    rules: []
  },
  paymentTyoe: {
    name: 'paymentTyoe',
    placeholder: 'Forma de pagamento',
    rules: []
  },
  product: {
    name: 'product',
    placeholder: 'Produto',
    rules: []
  },
  driver: {
    name: 'driver',
    placeholder: 'Nome',
    rules: []
  },
  salesManName: {
    name: 'salesManName',
    placeholder: 'Entregador',
    rules: []
  },
  resaleName: {
    name: 'resaleName',
    placeholder: 'Revenda',
    rules: []
  }
}
